//
//
//
//
//
//

export default {
  name: 'Declarations'
}
